import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AuthService } from './identity/services/auth/auth.service';
import { finalize } from 'rxjs/operators';
import { Constants } from './warr/common/constants';
import { environment } from 'src/environments/environment';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
@Component({
  selector: 'app-root',
  template: `
    <block-ui>
      <abp-loader-bar></abp-loader-bar>
      <abp-dynamic-layout></abp-dynamic-layout>
    </block-ui>
  `,
})
export class AppComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  constructor(
    private renderer: Renderer2,
    private authService: AuthService,
    private responsive: BreakpointObserver
  ) {}
  isMobile(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }

  ngOnInit() {
    this.renderer.listen('document', 'click', event => {
      const target = event.target as HTMLElement;
      const currentUser = target.closest('abp-current-user') as HTMLElement;
      if (!currentUser) return; // Click ngoài <abp-current-user>, bỏ qua
      const logoutElement = target.closest('#logout');
      if (logoutElement) {
        event.preventDefault();
        event.stopPropagation();
        this.logout();
      }
      const btn = target.closest('a.btn[role="button"]') as HTMLElement;
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      let loginUrl = `${environment.apis.login.url}/auth/login?returnUrl=${window.location.origin}`;
      // if (!this.isMobile()) {
      //   loginUrl = `${environment.apis.login.url}/auth/login?returnUrl=${window.location.origin}`;
      // } else {
      //   loginUrl = `https://auth.casper-electric.com/Account/Login`;
      // }
      this.responsive.observe([Breakpoints.Handset]).subscribe(result => {
        if (result.matches) {
          loginUrl = `${environment.apis.login.urlOld}`;
        } else {
          loginUrl = `${environment.apis.login.url}/auth/login?returnUrl=${window.location.origin}`;
        }
      });
      window.location.href = loginUrl;
    });
  }

  logout() {
    let token = localStorage.getItem('access_token');
    let loginUrl = `${environment.apis.login.url}/auth/login?returnUrl=${window.location.origin}`;

    this.authService
      .logout(token)
      .pipe(
        finalize(() => {
          localStorage.removeItem('access_token');
          localStorage.removeItem('expires_in');
          localStorage.removeItem(Constants.LocalKey.IsCasperEmployee);
        })
      )
      .subscribe(
        () => {
          window.location.href = loginUrl;
        },
        () => {
          window.location.href = loginUrl;
        }
      );
  }
}
